通用勾选框拓展
首字母排序，支持多选，支持搜索定位以及首字母查找定位

待补充点击分组字母跳转对应分组
<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <div class="sort-options-header" v-if="isShowSearch">
      <el-input v-model="searchVal" prefix-icon="icon-search" placeholder="请输入关键字以搜索" :trigger-on-focus="false">
      </el-input>
    </div>
    <template v-if="isMuti">
      <div v-if="isShowFirstCapital" class="sort-options-main">
        <div v-if="isSearching" class="searching" v-loading="isSearching"></div>
        <el-checkbox-group v-else-if="Object.keys(resultOptions).length > 0" v-model="mutiDatas"
          @change="handleCheckedChange" :disabled="isDisabled" class="sort-options">
          <template v-for="(value, key) in resultOptions">
            <div class="group" v-if="value.length > 0" :key="key">
              <div class="anchor" :data-anchor="key">{{key}}</div>
              <ul class="checkbox-list">
                <li v-for="(item,index) in value" :key="index">
                  <el-checkbox-button
                    :class="['background-'+item.value,{'el-checkbox--isCheckBox':isCheckBox}, {'label-long':item.label.length > 12}]"
                    :label="item.value" :disabled="item.isDisable" @change="handleSingleChange($event,item.value)">
                    <span>{{item.label}}</span>
                  </el-checkbox-button>
                </li>
              </ul>
            </div>
          </template>
        </el-checkbox-group>
        <div v-else class="result-empty">
          <img class="image" :src="require('@img/home/04search/pic_wuneirong.png')" />
          <div class="result-txt">
            <span class="search-name">“{{searchVal}}”</span>下无内容
            <br />请尝试更换关键词搜索
          </div>
        </div>
        <ul class="sort-options-right" v-if="!isSearching && searchVal.length == 0">
          <template v-for="(value, key) in sortOptions">
            <li v-if="value.length > 0" :key="key" @click="handleScrollTo(key)">{{key}}</li>
          </template>
        </ul>
      </div>
      <template v-else>
        <el-checkbox v-if="field.isShowAllBtn != false" v-model="chooseAll" @change="handleCheckAllChange"
          :disabled="isDisabled">全选</el-checkbox>
        <el-checkbox-group v-model="mutiDatas" @change="handleCheckedChange" :disabled="isDisabled">
          <el-checkbox-button v-for="(item,index) in options"
            :class="['background-'+item.value,{'el-checkbox--isCheckBox':isCheckBox}]" :key="index" border
            :label="item.value" :disabled="item.isDisable" @change="handleSingleChange($event,item.value)">
            {{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </template>
    </template>
    <el-checkbox v-else v-model="checked" :disabled="isDisabled" @change="handleChecked"></el-checkbox>
  </el-form-item>
</template>

<script>
import { isString } from "util";
import stringConfig from "../../../src/tools/stringConfig";
import stringPinyin from "../../../src/tools/stringPinyinConfig";
export default {
  data () {
    return {
      searchVal: "",
      timeout: null,
      itemClass: "self-checker-extend",
      checked: false,
      isDisabled: false,
      isMuti: false,  //是否是多个选项
      optionsAll: "",
      options: "",
      mutiDatas: [],  //当前多选选中的数据
      chooseAll: false,
      mutiDatasHistory: [], //多选框历史数据
      triggerType: "custom",//校验类型 custom是自定义的
      rules: [],
      isCheckBox: false, //是否是多选
      sortOptions: [], // 排序后选项列表
      resultOptions: [], // 搜索选项列表
      isSearching: false
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
    if (typeof (this.field.DEFAULT_VALUE) == "string")
      this.mutiDatasHistory = _.cloneDeep(this.field).DEFAULT_VALUE.split(","); //保存勾选前的历史数据 以便反选

    if (this.isRequired)
      this.itemClass += " self-checker-required";

    this.initData();
    this.initDict();
  },
  computed: {
    checkerClass: function () {
      return this.field.BUSI_CODE + "-check-all-box check-box-" + this.index;
    },
    title: function () {
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"]).length ? "" : "：") : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    messageChange: function () {
      return this.field.message;
    },
    dictChange: function () {
      return this.field.FIELD_DICT_FILTER || this.field.FIELD_DICT_NAME || this.field.FIELD_DICT_DISABLE;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    isShowSearch: function () { // 是否展示搜索框
      return this.field.SHOW_SEARCH || false;
    },
    isShowFirstCapital: function () { // 是否在列表中展示首字母
      return this.field.SHOW_FIRST_CAPITAL || false;
    },
  },
  methods: {
    handleSingleChange (isChoose, value) {
      if (isChoose) {
        this.field.FIELD_LAST_CHOOSE_VALUE = value;
      } else {
        this.field.FIELD_LAST_CHOOSE_VALUE = "";
      }
    },
    handleCheckAllChange (v) {
      let checkAll = this.options.map(item => {
        return item.value;
      });
      // this.mutiDatas = v ? checkAll  : this.mutiDatasHistory;     //反选恢复之前的数据 有还原所用不用反选恢复
      this.mutiDatas = v ? checkAll : "";
      this.field.DEFAULT_VALUE = this.mutiDatas ? this.mutiDatas.join(",") : "";
      if (this.options.length == this.mutiDatas.length) {
        this.chooseAll = true;
      }
    },
    handleCheckedChange (v) {
      if (v.length == this.options.length) {//全选
        this.chooseAll = true;
      } else {
        this.chooseAll = false;
      }
      this.field.DEFAULT_VALUE = v.join(",");
    },
    initDict () {
      if (this.isMuti && this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        this.optionsAll = [];
        this.options = [];
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        //展示但是不可编辑
        let disableArr = [];
        if (this.field.FIELD_DICT_DISABLE) {
          try {
            let disable = this.field.FIELD_DICT_DISABLE;
            disableArr = Array.isArray(disable) ? disable : isString(disable) ? disable.split(",") : [];
          } catch (exception) {
            disableArr = [];
          }
        }

        _.map(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO 不可编辑的要disable
          if (disableArr) {
            disableArr.map(i => {
              if (item.DICT_ITEM == i) {
                item.IS_DISABLE = true;
              }
            });
          }
          this.optionsAll.push({ "value": item.DICT_ITEM, "label": item.DICT_ITEM_NAME, "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false });
        });

        if (showArr.length == 0 || showArr.length == this.field.FIELD_DICT_NAME.length) {
          this.options = this.optionsAll;
        } else {
          // 如果当前值不在过滤后的字典内，将当前值清掉
          // 有可能是多选 DEFAULT_VALUE是多个带有,的值 进行优化修改
          let DEFAULT_VALUE = this.field.DEFAULT_VALUE ? this.field.DEFAULT_VALUE.split(",") : "";
          let NEW_DEFAULT_VALUE = [];
          _.each(DEFAULT_VALUE, item => {
            if (_.indexOf(showArr, item) > -1) {
              NEW_DEFAULT_VALUE.push(item);
            }
          });
          this.field.DEFAULT_VALUE = NEW_DEFAULT_VALUE.join(",");

          _.filter(this.field.FIELD_DICT_NAME, (item) => {
            // 判断机构ORG_CODE TODO 
            for (let j = 0; j < showArr.length; j++) {
              if (item.DICT_ITEM == showArr[j]) {
                this.options.push({ "value": item.DICT_ITEM, "label": item.DICT_ITEM_NAME, "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false });
              }
            }
            this.optionsAll.push({ "value": item.DICT_ITEM, "label": item.DICT_ITEM_NAME, "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false });
          });
        }

        if (this.field.DEFAULT_VALUE && this.optionsAll.length == this.field.DEFAULT_VALUE.split(",").length) {
          this.chooseAll = true;
        }
        if (this.isShowFirstCapital) {
          this.getSortOptions();
          this.resultOptions = this.sortOptions;
        }
      }
    },
    validatorField: function (rule, value, callback) {
      value = this.field.DEFAULT_VALUE;
      consoleLog("复选框 变化的新值", value);
      if (this.isBaseUI) { // 多选框选中和都不选中都广播值变更事件
        this.$emit("field-change", this.field);
      } else {
        this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
      }

      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) { // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.correct = true;
        this.showErrorMsg = "";
        this.field.message = "";
        this.field.showerr = false;
        return callback();
      }
    },
    initData () {
      if (this.field.DEFAULT_VALUE === "true") {
        this.checked = true;
        // this.field.DEFAULT_VALUE = "true";
        this.isMuti = false;
      } else if (this.field.DEFAULT_VALUE === "false") {
        this.checked = false;
        // this.field.DEFAULT_VALUE = "false";
        this.isMuti = false;
      } else if (this.field.DEFAULT_VALUE === false || this.field.DEFAULT_VALUE === true) {
        this.checked = this.field.DEFAULT_VALUE;
        this.isMuti = false;
      } else if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME.length == 0 && this.field.DEFAULT_VALUE == "") {
        //如果默认值为空字符，而且没有设置字典项则视为单选
        this.checked = this.field.DEFAULT_VALUE;
        this.isMuti = false;
      } else if (!this.field.FIELD_DICT_NAME && this.field.DEFAULT_VALUE == "") {
        this.checked = this.field.DEFAULT_VALUE;
        this.isMuti = false;
      } else { //多选
        this.isMuti = true;
        this.mutiDatas = this.field.DEFAULT_VALUE ? this.field.DEFAULT_VALUE.split(",") : [];
        // this.initDict();
      }
    },
    // 获取分组选项
    getSortOptions () {
      let sortOptions = {};
      sortOptions["#"] = [];
      for (let i = 0; i < 26; i++) {
        sortOptions[String.fromCharCode(65 + i)] = [];
      }
      this.options.map(item => {
        let str = item.label.substr(0, 1);
        if (stringConfig.isCHS(str)) { // 汉字
          str = stringPinyin.getFirstCapital(item.label);
        } else { // 数字或其它 存入#
          if (typeof sortOptions[str] == "undefined") {
            str = "#";
          }
        }
        sortOptions[str].push(item);
      });
      this.sortOptions = sortOptions;
    },
    handleChecked (value) {
      this.field.DEFAULT_VALUE = "" + value;
    },
    // 处理搜索改变
    handleSearchChange () {
      let val = this.searchVal,
        searchOptions = {};
      if (val.length == 0) {
        this.resultOptions = this.sortOptions;
        this.isSearching = false;
        return;
      }
      this.options.filter(item => {
        if (item.label.indexOf(val) == -1) {
          return;
        }
        let str = item.label.substr(0, 1);
        if (stringConfig.isCHS(str)) { // 汉字
          str = stringPinyin.getFirstCapital(item.label);
        }
        if (typeof searchOptions[str] == "undefined") {
          searchOptions[str] = [];
        }
        searchOptions[str].push(item);
      });
      this.resultOptions = searchOptions;
      this.isSearching = false;
    },
    handleScrollTo (key) {
      // 点击右侧快速选项跳转对应内容
      consoleLog("点击了", key);
      let that = this, top = 0;
      if (key != "#") {
        top = document.querySelector(".anchor[data-anchor=" + key + "]").offsetTop - 130;
      }
      try {
        document.querySelector(".sort-options").scrollTop = top;
      } catch (err) { consoleLog(err); }
    }
  },
  watch: {
    searchVal () {
      this.isSearching = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        this.handleSearchChange();
      }.bind(this), 500);
    },
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-checker-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-checker-required/g, "");
      }
    },
    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // }
    },
    dictChange: function (val) {
      this.initDict();
    },
    dataChange: function (val) {
      this.field.message = "";
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      this.initData();
    }
  }
};
</script>

<style lang="less">
.self-checker-extend {
  width: 100%;
  display: flex;
  .el-form-item__label {
    // font-size: 20px;//原始vtm
    font-size: 14px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    // font-size: 24px;原始vtm
    font-size: 14px;
    font-weight: 500;
    color: #232323;
    flex: 1;
    display: flex;
    flex-direction: column;
    .sort-options-header {
      flex: 0 0 66px;
      width: 684px;
      margin: 0 auto 60px auto;
      .el-input {
        .el-input__inner {
          padding: 0 60px;
        }
        .el-input__prefix {
          left: 0;
          top: 6px;
          .icon-search:before {
            content: "";
            display: inline-block;
            width: 32px;
            height: 32px;
            background: url("~@img/business/icon_sousuo.png") no-repeat;
          }
        }
      }
    }
    .sort-options-main {
      flex: 1;
      display: flex;
      align-items: flex-start;
      overflow: hidden;
      .el-checkbox-group.sort-options {
        flex: 1;
        height: 100%;
        overflow: hidden;
        overflow-y: auto;
        .group {
          .anchor {
            height: 50px;
            margin: 10px 0;
            padding-left: 40px;
            // font-size: 24px;原始vtm
            font-size: 14px;
            font-weight: 500;
            color: #1d1e20;
            line-height: 50px;
            background-color: #eff2f6;
          }
          .checkbox-list {
            display: flex;
            flex-wrap: wrap;
            > li {
              margin: 10px 66px 10px 0;
              .el-checkbox-button {
                .el-checkbox-button__inner {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  height: 80px;
                  width: 225px;
                  padding: 0 35px;
                  // font-size: 24px;原始vtm
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 36px;
                  color: #4a4e53;
                  border: 2px solid rgba(159, 162, 174, 1);
                  border-radius: 4px;
                  white-space: normal;
                  word-break: break-all;
                }
                &.label-long {
                  .el-checkbox-button__inner {
                    // font-size: 18px;原始vtm
                    font-size: 14px;
                  }
                }
                &.is-checked {
                  .el-checkbox-button__inner {
                    color: #1062d1;
                    border-color: #1062d1;
                    background-color: #d0dff5;
                  }
                }
                &.is-disabled {
                  .el-checkbox-button__inner {
                    color: #878d99;
                    background-color: #ebecf2;
                    border-color: #9fa2ae;
                  }
                }
              }
            }
          }
        }
      }
      .sort-options-right {
        flex: 0 0 18px;
        margin-left: 48px;
        width: 18px;
        padding: 0;
        li {
          line-height: 30px;
          // font-size: 18px;原始vtm
          font-size: 14px;          
          text-align: center;
        }
      }
      .searching {
        width: 100%;
        height: 200px;
      }
      .result-empty {
        width: 100%;
        padding-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .result-txt {
          margin: 11px 0 0;
          // font-size: 24px;原始vtm
          font-size: 14px;    
          font-weight: 500;
          line-height: 36px;
          color: #1a1a1a;
          text-align: center;
          .search-name {
            color: #1e64f3;
          }
        }
      }
    }

    .el-checkbox {
      display: inline-flex;
      align-items: center;
      margin-left: 20px;
      text-align: center;
      width: 285px;
      height: 80px;
      border: 2px solid rgba(159, 162, 174, 1);
      &.el-checkbox--isCheckBox {
        position: relative;
      }
      &.is-bordered {
        border-width: 2px;
        &.is-checked {
          background: rgba(16, 98, 209, 0.2);
          border-color: #1062d1;
        }
      }
      &.is-disabled {
        color: #878d99;
        background-color: #ebecf2;
        border-color: #9fa2ae;
      }
      &:first-child {
        margin-left: 0;
      }
    }
    .el-checkbox__input {
      vertical-align: bottom;
      display: none;
    }
    .el-checkbox__label {
      // font-size: 18px;原始vtm
      font-size: 14px;
      line-height: 50px;
    }
    .el-checkbox__inner {
      width: 36px;
      height: 36px;
      border-color: #aaaaaa;
      &::after {
        height: 20px;
        left: 11px;
        top: 2px;
        width: 12px;
        border-color: #fff;
      }
      &:hover {
        border-color: #9dcd17;
      }
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #9dcd17;
      border-color: #9dcd17;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
      border-color: #fff;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      // color: inherit;
    }
    .el-checkbox__input.is-checked.is-disabled .el-checkbox__inner {
      background-color: #b0b0b0;
      border-color: #b0b0b0;
    }
  }
}

.self-checker-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/checkerItemExtend.vue